import React, { Component } from 'react'
import { connect } from 'react-redux'
import Http from './Http'

export default class Geolocation extends Component{
	render(){
		let { props } = this
		let requestData = JSON.stringify({
			address: props.address.trim().replace(/\s/g, '+')
		  , key: "AIzaSyDEBvdeonv4WWGW_m5S2M0yOH9DnWabwik"
		})
		return(
			<Http
				method="GET"
				url={`https://maps.googleapis.com/maps/api/geocode/json`}
				data={requestData}
				onSuccess={props.onSuccess}
				onError={(resp) => console.log(resp)}
				post={true}
			/>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/drivers/Geolocation.js